import React from 'react';
import { useNavigate } from 'react-router-dom';
import OAuth2Login from 'react-simple-oauth2-login';

const AuthOptions = () => {
  const navigate = useNavigate();
  
  const providers = [
    { name: "Google", baseUrl: "https://auth.prompteh.com/authorize", providerParam: "google" },
  ];

  const onSuccess = (response) => {
    console.log('Login success:', response);
    navigate('/callback');
  };

  const onFailure = (response) => {
    console.error('Login failure:', response);
    alert('Login failed. Please try again.');
  };

  const handleContinueToFree = () => {
    console.log('Continuing to free version...');
    try {
      localStorage.setItem('user', JSON.stringify({ tier: 'free' }));
      console.log('User data saved to localStorage');
      
      // Force a page reload after setting localStorage to ensure the app re-evaluates the state
      window.location.href = '/';
    } catch (error) {
      console.error('Error in handleContinueToFree:', error);
      window.location.href = '/'; // Fallback if something goes wrong
    }
  };

  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="flex flex-col gap-6 max-w-md mx-auto p-8 content-container rounded-lg shadow-[0px_0px_10px_rgba(0,0,0,0.9)]">
        <h2 className="text-2xl font-semibold text-center">Welcome to Prompteh</h2>
        <p className="text-gray-600 text-center">Choose how you'd like to continue:</p>
        
        <div className="flex flex-col gap-4">
          {/* Single Turnstile widget for both options */}
          {/* <div className="cf-turnstile mb-4"></div> */}
          
          {/* Google login section */}
          <div>
            {providers.map(provider => (
              <OAuth2Login
                key={provider.name}
                authorizationUrl={provider.baseUrl}
                responseType="code"
                clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID || `your-${provider.name.toLowerCase()}-client-id`}
                redirectUri="https://app.prompteh.com/callback"
                onSuccess={onSuccess}
                onFailure={onFailure}
                buttonText={`Login with ${provider.name}`}
                className="w-full px-4 py-3 bg-gradient-to-r from-[#0078D4] to-[#00A4B4] text-white rounded-lg hover:scale-105 transition-transform text-center mt-4"
                isCrossOrigin={true}
                extraParams={{ provider: provider.providerParam }}
                // isDisabled={!isVerified}
              />
            ))}
          </div>
          
          {/* Free version section */}
          <div>
            <button 
              onClick={handleContinueToFree} 
              className="w-full px-4 py-3 bg-gradient-to-r from-[#0078D4] to-[#00A4B4] text-white rounded-lg hover:scale-105 transition-transform mt-4"
              // disabled={!isVerified}
            >
              Continue to Free Version
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AuthOptions;
